import { render, staticRenderFns } from "./PreferencesBasicInfo.vue?vue&type=template&id=4bbe7b54"
import script from "./PreferencesBasicInfo.vue?vue&type=script&lang=js"
export * from "./PreferencesBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./PreferencesBasicInfo.vue?vue&type=style&index=0&id=4bbe7b54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports